import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import HistoryCard from "../historyCard/HistoryCard";
import TeamSearch from "../teamSearch/TeamSearch";
import { getUserLogsByCompanyService } from "../../services/logs/services";
import Loading from "../loading/Loading";
import Pagination from "../pagination/Pagination";
import { getUsersByCompanyService } from "../../services/user/services";
import NoResults from "../noResults/noResults";
import { PERMISSION_CODE } from "../../utils/enum/enums";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const PAGE_SIZE = 10;

const HistoryTeam = () => {
  const { user } = useSelector((state) => state.user);
  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );

  const [agent, setAgent] = useState("all");
  const [agents, setAgents] = useState([]);
  const [type, setType] = useState("all");
  const [histories, setHistories] = useState([]);
  const [page, setPage] = useState(1);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalHistories, setTotalHistories] = useState(0);
  const [isLoadingHistories, setIsLoadingHistories] = useState(false);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [error, setError] = useState(null);

  const getHistories = useCallback(async () => {
    try {
      setIsLoadingHistories(true);
      setError(null);
      const json = await getUserLogsByCompanyService({
        companyId: company?._id,
        category: type,
        agent,
        page,
        pageSize: PAGE_SIZE.toString(),
      });

      if (json?.logs?.error) {
        setHistories([]);
        setTotalHistories(0);
        setPageNumber(0);
        setError(json.error);
        return;
      }

      setHistories(json?.logs ?? []);
      const count = json?.totalRecords ?? 0;
      setTotalHistories(count);
      setPageNumber(Math.ceil(count / PAGE_SIZE));
    } catch (err) {
      console.error(err);
      setError("Error cargando historial");
      setHistories([]);
    } finally {
      setIsLoadingHistories(false);
    }
  }, [agent, company?._id, page, type]);

  const getUsers = useCallback(async () => {
    try {
      setIsLoadingUsers(true);
      const json = await getUsersByCompanyService({ companyId: company?._id });

      if (
        json?.code === PERMISSION_CODE.PERMISSION_DENIED ||
        json?.users?.error ||
        json?.users?.length === 0 ||
        json?.users?.code === PERMISSION_CODE.PERMISSION_DENIED
      ) {
        setAgents([]);
        return;
      }

      setAgents(json?.users ?? []);
    } catch (err) {
      console.error(err);
      setError("Error cargando usuarios");
    } finally {
      setIsLoadingUsers(false);
    }
  }, [company?._id]);

  useEffect(() => {
    if (company?._id) getUsers();
  }, [company?._id, getUsers]);

  useEffect(() => {
    getHistories();
  }, [getHistories]);

  if (userLoading || companyLoading) return null;

  return (
    <>
      <TeamSearch
        agents={agents}
        setAgent={setAgent}
        type={type}
        setType={setType}
      />

      {isLoadingUsers || isLoadingHistories ? (
        <Loading />
      ) : error ? (
        <NoResults message={error} />
      ) : histories?.length === 0 ? (
        <NoResults message="No historial encontrado" />
      ) : (
        <div className="grid gap-6 mb-6 md:grid-cols-1">
          <HistoryCard histories={histories} />
          <Pagination
            key="paginationLogs"
            page={page}
            setPage={setPage}
            pageNumber={pageNumber}
            totalRecords={totalHistories}
            pageSize={PAGE_SIZE}
          />
        </div>
      )}
    </>
  );
};

export default HistoryTeam;
